export const CLEAR_ERROR = "CLEAR_ERROR";